export default [
  { title: "Main", text: "Know Your Risk" },
  { title: "About", text: "About Us" },
  { title: "Contact", text: "Contact Us" },
  { title: "Search", text: "Search Your Radar" },
  { title: "Article", text: "News" }
];
